class Referrals {
  public refType = null;
  public referralCode: string = '';
}
export class ReferralStats {
  public referrals: Array<Referrals> = [];
  public incentiveQuantityUOM: string = '';
  public totalFixedPoints: string = '';
  public totalVariablePoints: string = '';
  public variableIncentiveEnabled: boolean = false;
  public referralLevels: string = '';
}
